
import Vue from 'vue'

/**
 * 创建跟随鼠标的提示信息
 * @param text
 * @returns {HTMLElement}
 */
function createCursor(viewer,text) {
  if(document.getElementById('cursortip')){
    document.getElementById('cursortip').innerText=text
    return document.getElementById('cursortip')
  }
  const tip=document.createElement('div')
  tip.id='cursortip'
  tip.style.position='absolute'
  tip.style.backgroundColor='rgba(0, 0, 0, 0.5)'
  tip.innerText=text
  tip.style.width='108px'
  tip.style.fontFamily='宋体'
  tip.style.fontSize='10px'
  tip.style.padding='3px'
  tip.style.color='white'
  document.body.appendChild(tip)
  document.body.addEventListener('mousemove',function (e) {
    if(document.getElementById('cursortip')){
      e.preventDefault()
      const div=document.getElementById('cursortip')
      if(e.target===viewer.canvas){
        div.style.display='block'
        div.style.left=e.offsetX+10+'px'
        div.style.top=e.offsetY+10+'px'
      }else{
        div.style.display='none'
      }
    }
  })
  return tip
}
window.createCursor=createCursor


export {createCursor}
